// CUSTODY — SETTINGS (his custody redesign, yes on 2 Nov 2026; the drawing s7): everything he sets rarely, in one place —
// the limits, the fee floors, renewals and the desk window (custody-admin/Settings.tsx: edit, review before → after, save),
// then the devices and keys (custody-admin/Keys.tsx). The rules and the saves are the wallet's own; this screen only places
// them under the section's head and tabs.
import { CustodyHead, CustodyTabs } from '../../../components/v2/custody/parts';
import { CustodySettingsV2 } from '../custody-admin/Settings';
import { KeysV2 } from '../custody-admin/Keys';

export function CustodySettingsScreenV2() {
  return (
    <div className="lg:max-w-[1160px]">
      <CustodyHead />
      <CustodyTabs current="settings" />
      <CustodySettingsV2 embedded />
      <KeysV2 embedded />
    </div>
  );
}
